// Central registry for node shape strategies

import type { ShapeDefinition } from '@/modules/Node';

const registry: Record<string, ShapeDefinition> = {};

function registerShape(shape: ShapeDefinition): void {
  registry[shape.value] = shape;
}

function getShape(value: string): ShapeDefinition {
  const shape = registry[value];
  if (!shape) {
    throw new Error(`Unknown node shape: "${value}"`);
  }
  return shape;
}

export { registerShape, getShape };
